import {Operation} from "./Operation.js";

export class Multiply extends Operation {

    static symbol = "*";

    /**
     * Perform multiplication on the two values.
     * @param {Row} row - A row object containing the values to multiply.
     */
    perform(row) {
        const [leftValue, rightValue] = this.getOperands(row);
        return (leftValue || 0) * (rightValue || 0);
    }
}